import {Injectable} from '@angular/core';
import {DialogService} from '@shared/services/dialog-service';
import {DialogModel} from '@shared/models/dialog.model';
import {Observable, Subject} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EatFlowChartService {
  constructor(private dialogService: DialogService) {

  }

  openDesignQuestionare(title: string, section: any, sourceType: string, flowchart: any, minWidth = '900px', maxWidth= '900px') {
    const dialogueModel = DialogModel.create(title,
      'DesignQuentionareDialogComponent',
      {section: section, sourceType: sourceType, flowchart: flowchart}, minWidth, maxWidth);
    dialogueModel.okCaption = 'Done';
    return this.dialogService.showOkCancelDialog(dialogueModel);
  }
  openResponseQuestionare(title: string, section: any, sourceType: string, flowchart: any, rowItem: any, surveyId: string, minWidth = '900px', maxWidth= '900px') {
    const dialogueModel = DialogModel.create(title,
      'ResponseQuentionareDialogComponent',
      {section: section, sourceType: sourceType, flowchart: flowchart, rowItem: rowItem, surveyId: surveyId}, minWidth, maxWidth);
    dialogueModel.okCaption = 'Done';
    return this.dialogService.showOkCancelDialog(dialogueModel);
  }
}
